import React from 'react';
import styled from 'styled-components';
import { withLocalePrefix } from 'shared/utils/translation';
import RichTextWithMentions from 'shared/components/rich_text_with_mentions';
import { useFormContext } from '@grnhse/seedling/lib/birch/components/forms/form';

const t = withLocalePrefix('talent_matching.bulk_actions.feedback');

const Content = styled.div`
  & .trix-button-row {
    display: none;
  }

  & trix-editor {
    min-height: 160px;
  }
`;

type Props = {
  getTagsUrl: string;
  value?: string;
};

const FeedbackTextField = ({ getTagsUrl, value }: Props) => {
  const { setValue } = useFormContext();
  return (
    <Content className="pii-blur">
      <RichTextWithMentions
        hiddenFieldName="scoredcard_feedback"
        taggedFieldName="scorecard_feedback_with_tags"
        value={value || ''}
        required={false}
        onSetNote={(note: string) => setValue('notes', note)}
        onSetNoteWithTags={(note: string) => setValue('notes_with_tags', note)}
        getTagsUrl={getTagsUrl}
        placeholder={t('labels.leave_feedback')}
      />
    </Content>
  );
};

export default FeedbackTextField;
